import { STRINGS } from '@/shared/config'
import { TABLE_PAGE_SIZE_OPTIONS } from '@/shared/lib/query'
import { TableWrapper } from '@/shared/ui'
import { SearchOutlined } from '@ant-design/icons'
import { Flex, Input, Table, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { type GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem } from '../../api'
import {
  $isLoadingMore,
  $searchQuery,
  searchQueryChanged,
} from '../../model/statistics-authors-data.model'
import {
  $limit,
  $page,
  $tableData,
  $tableTotalItems,
  limitChanged,
  pageChanged,
  sortByChangedBySorterResult,
} from '../../model/statistics-authors-data.model'
import { useAuthorsStatisticsTableColumns } from './useAuthorsStatisticsTableColumns'

interface AuthorsStatisticsTableProps {
  onRowClick?: (authorId: string) => void
}
export const AuthorsStatisticsTable = ({
  onRowClick: _onRowClick,
}: AuthorsStatisticsTableProps) => {
  const data = useUnit($tableData)
  const loading = useUnit($isLoadingMore)
  const totalItems = useUnit($tableTotalItems)
  const limit = useUnit($limit)
  const changeLimit = useUnit(limitChanged)
  const page = useUnit($page)
  const changePage = useUnit(pageChanged)
  const search = useUnit($searchQuery)
  const changeSearch = useUnit(searchQueryChanged)

  const changeSortBySorterResult = useUnit(sortByChangedBySorterResult)
  const tableColumns: TableProps<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>['columns'] =
    useAuthorsStatisticsTableColumns()

  const onTableChange: TableProps<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>['onChange'] =
    (pagination, _filters, sorter) => {
      // Sort
      if (!Array.isArray(sorter)) {
        changeSortBySorterResult(sorter)
      }
      // Pagination
      if (pagination.current && pagination.pageSize) {
        if (pagination.current !== page) {
          changePage(pagination.current)
        }
        if (pagination.pageSize !== limit) {
          changeLimit(pagination.pageSize)
        }
      }
    }

  const pagination: TableProps<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>['pagination'] =
    {
      current: page,
      pageSize: limit,
      total: totalItems,
      showSizeChanger: true,
      pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
      locale: { items_per_page: 'на странице' },
    }

  const rowKey: TableProps<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>['rowKey'] =
    (record) => record.id

  return (
    <>
      <Flex justify="end" style={{ marginBottom: 16 }}>
        <Input
          placeholder={STRINGS.placeholder_search_input}
          allowClear
          addonAfter={<SearchOutlined />}
          value={search || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const searchQueryString = event.target.value
            changeSearch(searchQueryString)
          }}
          style={{
            width: '100%',
            maxWidth: 400,
          }}
        />
      </Flex>
      <TableWrapper>
        <Table
          scroll={{ x: 'max-content', y: 400 }}
          sticky
          showSorterTooltip={false}
          rowKey={rowKey}
          bordered
          loading={loading}
          columns={tableColumns}
          dataSource={data}
          onChange={onTableChange}
          pagination={pagination}
        />
      </TableWrapper>
    </>
  )
}
